/*
 * @Author: cryi.liu
 * @Date: 2020-05-06 10:08:43
 * @LastEditTime: 2020-05-06 11:20:01
 * @Description: 全局组件注册
 */
import PssButton from '../components/common/Button.vue';

const Plugin = {
  install: (Vue) => {
    // 原 PSS 风格按钮
    Vue.component('pss-button', PssButton);
  },
};

export default Plugin;
